import { SET_UNITS } from '../actions/actiontypes';
import { alphabetical, groupByProperty } from '../../utils/collections';
import { camelize } from '../../utils/strings';

function convertToApp(entity) {
  const newEntity = { ...entity };
  camelize(newEntity, 'name_abbr', false);
  camelize(newEntity, 'name_long', false);
  camelize(newEntity, 'data_type', false);
  camelize(newEntity, 'raw_encoding', false);
  camelize(newEntity, 'displayEncoding', false);
  camelize(newEntity, 'unitType', false);
  return newEntity;
}
const unitReducer = (state = { all: [], byId: {}, byName: {} }, action) => {
  switch (action.type) {
    case SET_UNITS: {
      const units = action.data?.map(convertToApp) || [];
      return {
        all: alphabetical('name_long', units),
        byId: groupByProperty('id', units),
        byName: groupByProperty('name_abbr', units),
      };
    }
    default:
      return state;
  }
};

export default unitReducer;
